<template>
    <div>
        <v-modal-contents ref="modal_contents_agree">

            <template v-slot:close>
                <!--        убираем close-->
                <div></div>
            </template>

            <template v-slot:title>

                <div class="terms_of_use__title mt-30 pl-3 ">
                    <div class="h2_title">Условия использования персональных данных</div>

                </div>

            </template>
            <template v-slot:content>
                <div class="terms_of_use mt-30 ">
                    <div v-html="terms"></div>
                    <div class="mt-30">
                        <button class="px-30 btn-red "
                                @click="$refs.modal_contents_agree.modal_open()">
                            Прочитал
                        </button>

                    </div>
                </div>
            </template>
        </v-modal-contents>
        <v-form ref="form" class=" form-contract" v-model="valid" lazy-validation>
            <div class="row mx-0 my-0">
                <div class="col-12 col-md-6 col-lg-6 p-md-2">
                    <h2 class="formNew_h2">
                        Оставьте заявку на коммерческое предложение
                    </h2>
                </div>

                <div class="col-12 col-md-6 col-lg  p-0">
                    <div class="col-12">
                        <div class="form-contract__item position-relative">
                            <v-text-field class="form-contract__input"
                                          v-model="name"
                                          :rules="nameRules"
                                          id="name"
                            >
                                <template v-slot:label>
                                    ФИО *
                                </template>
                            </v-text-field>

                        </div>
                    </div>
                    <div class="row mx-0 my-0">
                        <div class="col-12 col-md-6 ">
                            <div class="form-contract__item">
                                <v-text-field class="form-contract__input"
                                              v-model="email"
                                              :rules="emailRules"
                                              oninput="this.value = this.value.trim()"
                                              id="email"
                                >
                                    <template v-slot:label>
                                        Электронная почта *
                                    </template>
                                </v-text-field>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-contract__item">
                                <v-text-field
                                        v-model="tel"
                                        :rules="telRules"
                                        id="tel"
                                        oninput="this.value = this.value.replace(/[^\d]/g,'');this.value = this.value.slice(0,10); "
                                        class=" form-contract__input"
                                        max="20"
                                >
                                    <template v-slot:label>
                                        Телефон *
                                    </template>
                                </v-text-field>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 ">
                        <div class="form-contract__item role">
                            <v-select
                                    :items="product_types"
                                    item-value="id"
                                    label="Тип продукции *"
                                    v-model="product_type"
                                    required=""
                                    :rules="requiredRules"
                                    append-icon="mdi mdi-chevron-down"
                                    id="product_type"
                                    class="form-contract__input"
                                    :menu-props="{ contentClass: 'wrapp_role' }"
                                    return-object
                            >

                                <template v-slot:item="{item}">
                                    {{ item.name }}
                                </template>
                                <template v-slot:selection="{item}">
                                    {{ item.name }}
                                </template>
                            </v-select>
                        </div>
                    </div>

                    <div class="row mx-0 my-0">

                        <div class="col-12 col-md-6">
                            <div class="form-contract__item position-relative">
                                <v-text-field class="form-contract__input"
                                              v-model="product_weight"
                                              :rules="requiredRules"
                                              id="product_weight"
                                >
                                    <template v-slot:label>
                                        Вес продукта *
                                    </template>
                                </v-text-field>

                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-contract__item position-relative">
                                <v-text-field class="form-contract__input"
                                              v-model="product_color"
                                              :rules="requiredRules"
                                              id="product_color"
                                >
                                    <template v-slot:label>
                                        Цвет продукта *
                                    </template>
                                </v-text-field>

                            </div>
                        </div>

                        <!--                <div class="px-3 py-3 w-100">-->
                        <!--                    <div class="form-contract__grid">-->
                        <!--                        <div class="column col-md-12 px-0 py-0 form-contract__background">-->
                        <!--                            <div class="col-12 col-md-12 pb-5 px-0 pt-0">-->
                        <!--                                <div class="form-contract__item role">-->
                        <!--                                    <v-select-->
                        <!--                                            :items="group_items"-->
                        <!--                                            item-value="id"-->
                        <!--                                            label="Упаковка групповая: выбор типа упаковки"-->
                        <!--                                            v-model="group_item"-->
                        <!--                                            required=""-->
                        <!--                                            :rules="requiredRules"-->
                        <!--                                            append-icon="mdi mdi-chevron-down"-->
                        <!--                                            id="group_item"-->
                        <!--                                            class="form__input"-->
                        <!--                                            :menu-props="{ contentClass: 'wrapp_role' }"-->
                        <!--                                            return-object-->
                        <!--                                    >-->

                        <!--                                        <template v-slot:item="{item}">-->
                        <!--                                            {{item.name}}-->
                        <!--                                        </template>-->
                        <!--                                        <template v-slot:selection="{item}">-->
                        <!--                                            {{item.name}}-->
                        <!--                                        </template>-->
                        <!--                                    </v-select>-->


                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                            <div class="col-12 col-md-12 pb-0 px-0 pt-0">-->
                        <!--                                <div class="form-contract__item position-relative">-->
                        <!--                                    <v-text-field class="form__input"-->
                        <!--                                                  v-model="group_type"-->
                        <!--                                                  :rules="requiredRules"-->
                        <!--                                    >-->
                        <!--                                        <template v-slot:label>-->
                        <!--                                            Тип маркировки на групповой упаковке-->
                        <!--                                        </template>-->
                        <!--                                    </v-text-field>-->

                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <!--                        <div class="column col-md-12 px-0 py-0 form-contract__background">-->
                        <!--                            <div class="col-12 col-md-12 pb-5 px-0 pt-0">-->
                        <!--                                <div class="form-contract__item role">-->
                        <!--                                    <v-select-->
                        <!--                                            :items="single_items"-->
                        <!--                                            item-value="id"-->
                        <!--                                            label="Упаковка единичная: выбор коробки"-->
                        <!--                                            v-model="single_item"-->
                        <!--                                            required=""-->
                        <!--                                            :rules="requiredRules"-->
                        <!--                                            append-icon="mdi mdi-chevron-down"-->
                        <!--                                            id="single_item"-->
                        <!--                                            class="form__input"-->
                        <!--                                            :menu-props="{ contentClass: 'wrapp_role' }"-->
                        <!--                                            return-object-->
                        <!--                                    >-->

                        <!--                                        <template v-slot:item="{item}">-->
                        <!--                                            {{item.name}}-->
                        <!--                                        </template>-->
                        <!--                                        <template v-slot:selection="{item}">-->
                        <!--                                            {{item.name}}-->
                        <!--                                        </template>-->
                        <!--                                    </v-select>-->


                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                            <div class="col-12 col-md-12 pb-0 px-0 pt-0">-->
                        <!--                                <div class="form-contract__item position-relative">-->
                        <!--                                    <v-text-field class="form__input"-->
                        <!--                                                  v-model="single_type"-->
                        <!--                                                  :rules="requiredRules"-->
                        <!--                                                  id="single_type"-->
                        <!--                                    >-->
                        <!--                                        <template v-slot:label>-->
                        <!--                                            Тип маркировки на единичной упаковке-->
                        <!--                                        </template>-->
                        <!--                                    </v-text-field>-->

                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <!--                    </div>-->
                        <!--                </div>-->

                    </div>

                    <div class="col-12 col-md-12 pb-3 px-3 pt-3">
                        <!-- SmartCaptcha -->
                        <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'"
                             class="w-100 mt-30"></div>

                        <div class="form-contract__item  mt-30">
                            <v-checkbox
                                    v-model="checkbox"
                                    :rules="[(v) => !!v || 'Это обязательный пункт']"
                                    required
                                    color="red"
                            >
                                <template v-slot:label>
                                    <div class="customLabelForm">
                                        Я выражаю согласие с
                                        <a href="javascript:void(0);" target="_blank"
                                           @click="$refs.modal_contents_agree.modal_open('scroll_false')">
                                            условиями использования
                                        </a>
                                        моих персональных данных для обработки данного обращения ООО «Компания Нова
                                        Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское
                                        шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю согласие с
                                        <a :href="policy" @click="linkOpen(policy)" class="position-relative zi-1">
                                            Политикой конфиденциальности
                                        </a> и
                                        <a :href="agreement" @click="linkOpen(agreement)"
                                           class="position-relative zi-1">
                                            Пользовательским соглашением.
                                        </a>
                                    </div>
                                </template>
                            </v-checkbox>
                            <v-checkbox
                                    v-model="consentToInform"

                                    color="red"
                                    class="mt-0"
                            >
                                <template v-slot:label>
                                    <div class="customLabelForm">
                                        Я выражаю согласие на информирование меня о продуктах, акциях, выгодных
                                        предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206,
                                        Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и
                                        партнеров.
                                    </div>
                                </template>
                            </v-checkbox>

                            <div class="btn_form d-flex align-items-center justify-content-start">
                                <button :disabled="!valid" class="px-30 btn-red w-mc " type="button"
                                        @click="sendForm">
                                    Получить коммерческое предложение
                                </button>
                            </div>
                        </div>

                    </div>
                </div>


            </div>


        </v-form>
    </div>

</template>
<script>
import VModalContents from "./modal_contents.vue";

export default {
    components: {
        VModalContents: VModalContents,
    },
    name: "formContract",
    props: {
        pt: Array | String | Number | Boolean | Object,
        spt: Array | String | Number | Boolean | Object,
        gpt: Array | String | Number | Boolean | Object,
        policy: String | Boolean,
        agreement: String | Boolean,
        terms: String | Boolean,
    },
    data() {
        return {
            captchaPassed: false,
            valid: true,

            name: "",
            nameRules: [
                (v) => !!v || "Обязательное поле",
                (v) => (v && v.length >= 3) || "Поле не может быть меньше 3 символов",
            ],

            email: "",
            emailRules: [
                (v) => !!v || "Обязательное поле",
                (v) => /.+@.+\..+/.test(v) || "Неккоректная электронная почта",
            ],

            tel: "",
            telRules: [
                (v) => !!v || "Обязательное поле",
                (v) =>
                    /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(v) ||
                    "Неккоректный телефон",
            ],

            requiredRules: [
                (v) => !!v || "Обязательное поле",
            ],

            product_type: null,
            // product_types: this.product_types,

            /*product_types: [
                {name: "Тип продукции 1", id: "887"},
                {name: "Тип продукции 2", id: "776"},
                {name: "Тип продукции 3", id: "876"},
                {name: "Тип продукции 4", id: "334"},
            ],*/
            product_types: this.pt,

            product_weight: null,
            product_color: null,

            group_item: null,
            // group_items: this.group_items,

            /*group_items: [
                {name: "Тип упаковки 1", id: "887"},
                {name: "Тип упаковки 2", id: "776"},
                {name: "Тип упаковки 3", id: "876"},
            ],*/
            group_items: this.gpt,

            single_item: null,
            // single_items: this.single_items,

            /*single_items: [
                {name: "Тип упаковки 1", id: "887"},
                {name: "Тип упаковки 2", id: "776"},
                {name: "Тип упаковки 3", id: "876"},
            ],*/
            single_items: this.spt,

            group_type: "",
            single_type: "",

            checkbox: false,
            consentToInform: false,

            // upload drag-and-drop file
            filelist: [],
        };
    },

    methods: {
        linkOpen(url) {
            window.open(url, '_blank');
        },
        // Captcha
        initCaptcha() {
            window.smartCaptcha.render('captcha-container', {
                sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
                callback: this.onCaptchaSuccess,
            });
        },
        onCaptchaSuccess(token) {
            this.captchaPassed = true;
            this.form.captchaToken = token;
        },
        // Captcha end
        reset() {
            this.$refs.form.reset();
        },
        sendForm() {
            if (!this.$refs.form.validate()) return false;
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
            /** AJAX */
            var VueObject = this;
            var formData = new FormData();

            $.each(VueObject.filelist, function (key, value) {
                formData.append(key, value);
            });

            formData.append("name", VueObject.name);
            formData.append("email", VueObject.email);
            formData.append("phone", VueObject.tel);
            formData.append("product_type", VueObject.product_type.id);
            formData.append("product_type_name", VueObject.product_type.name);
            formData.append("product_weight", VueObject.product_weight);
            formData.append("product_color", VueObject.product_color);
            // formData.append("single_package", VueObject.single_item.id);
            // formData.append("single_package_name", VueObject.single_item.name);
            // formData.append("single_package_mark", VueObject.single_type);
            // formData.append("group_package", VueObject.group_item.id);
            // formData.append("group_package_name", VueObject.group_item.name);
            // formData.append("group_package_mark", VueObject.group_type);

            formData.append("ajaxPost", "Y");


            let url = "/ajax/contract-development-form.php";

            fetch(url, {method: "POST", body: formData})
                .then(function (response) {
                    return response.json();
                })
                .then((data) => {
                    console.log(data);
                    $(".text_result").slideDown(300);
                    $(".text_result").delay(3000).slideUp(300);

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "FormSubmitBitrix",
                        formName: "Оставьте заявку",
                        pageUrl: window.location.pathname
                    });

                    VueObject.$refs.form.reset();

                    setTimeout(function () {
                        window.location.reload()
                    }, 3000);
                });
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },


        // upload drag-and-drop file

        onChange() {
            this.filelist = [...this.$refs.file.files];
        },
        remove(i) {
            this.filelist.splice(i, 1);
        },
        dragover(event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains("bg-green-300")) {
                event.currentTarget.classList.remove("bg-gray-100");
                event.currentTarget.classList.add("bg-green-300");
            }
        },
        dragleave(event) {
            // Clean up
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange(); // Trigger the onChange event manually
            // Clean up
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
        },

        // upload drag-and-drop file end

    },
    created() {
        setTimeout(() => {
            this.initCaptcha();
        }, 500)
    },
    watch: {
        captchaPassed() {
            // this.sendForm();
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
        },
    }
};
</script>

<style lang="scss">

.wrapp_role.v-menu__content {
  margin-top: 51px;
}

.contract {

  .smart-captcha.error-captcha:before {
    background: transparent;
    color: #FA4237;
    transform: translateY(-8px);
  }


  & .form-contract {
    box-sizing: border-box;
    border-radius: 40px;
    background: #F5F5F7;
    padding: 12px;

    &__grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
      width: 100%;

      @media (max-width: 960px) {
        grid-template-columns: 1fr;
      }
    }

    &__background {
      padding: 20px !important;
      border-radius: 10px;
      background: #F8F8F8;
    }

    &__item {
      padding-left: 0;

      & ul {
        list-style: none;
        margin-left: 22px;
      }

      & label {
        @media (max-width: 550px) {
          font-size: 15px !important;
        }
      }
    }

    &__input {
      width: auto;
      border: 1px solid #F0F0F0;
      background: #FFFFFF;
      border-radius: 6px;
      padding: 25px 15px !important;
      margin: 0 !important;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      color: #282828;
      resize: none;
    }

    & h2.formNew_h2 {
      font-family: "MuseoSansCyrl-500";
      font-weight: 400;
      font-size: 52px;
      leading-trim: NONE;
      line-height: 68px;
      letter-spacing: -1.04px;
      vertical-align: middle;

      @media (max-width: 1000px) {
        font-size: 46px;
        line-height: 56px;
      }

      @media (max-width: 650px) {
        font-size: 38px;
        line-height: 44px;
      }

      @media (max-width: 500px) {
        font-size: 30px;
        line-height: 36px;
      }

    }

    & .smart-captcha {
      min-width: 250px;
    }

    &__item .primary--text {
      color: #656565 !important;
      caret-color: #656565 !important;
    }

    & .v-text-field__details {
      position: absolute;
      display: flex;
      transform: translate(-1px, 40px);
    }

    & .v-input__slot {
      margin: 0 !important;

      &::before {
        display: none !important;
      }

      &::after {
        display: none !important;
      }
    }
  }

}

</style>